document.addEventListener("DOMContentLoaded", () => {
  const loadMoreImagesBtn = document.querySelector(
    "#load-more-product-media-images"
  );
  const hidePartImagesBtn = document.querySelector(
    "#hide-part-product-media-images"
  );
  const imagesList = document.querySelector(
    ".product__media-list.contains-media"
  );
  if (!imagesList || !loadMoreImagesBtn || !hidePartImagesBtn) return;

  const imagesListElements = imagesList.querySelectorAll(
    "li.product__media-item"
  );

  if (imagesListElements && imagesListElements.length > 0) {
    loadMoreImagesBtn.addEventListener("click", () => {
      const numberOfVisibleImages = imagesList.dataset.numberOfVisibleImages;
      console.log("x");
      imagesListElements.forEach((el, i) => {
        if (i > numberOfVisibleImages - 1) {
          el.classList.remove("hide-image");
        }
      });
      loadMoreImagesBtn.classList.add("hide-button");
      hidePartImagesBtn.classList.remove("hide-button");
    });
    hidePartImagesBtn.addEventListener("click", () => {
      const numberOfVisibleImages = imagesList.dataset.numberOfVisibleImages;
      imagesListElements.forEach((el, i) => {
        if (i > numberOfVisibleImages - 1) {
          el.classList.add("hide-image");
        }
      });
      loadMoreImagesBtn.classList.remove("hide-button");
      hidePartImagesBtn.classList.add("hide-button");
    });
  }
});
